import React, { useState, useEffect } from 'react'

import './Countdown.scss'

export const Countdown = ({ time, onExpire, showCountdown = false }) => {
  const [timeLeft, setTimeLeft] = useState(time)
  const percentRemaining = (timeLeft / time) * 100
  const progressPercentage = Math.min(100, (100 - percentRemaining).toFixed(0))

  useEffect(() => {
    if (timeLeft < 0) {
      onExpire()
      return
    }

    let timerId = setTimeout(() => {
      setTimeLeft(timeLeft - 1)
    }, 1000)

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timerId)
      timerId = null
    }
  }, [timeLeft, onExpire])

  if (!showCountdown) {
    return null
  }

  return (
    <div className="countdown-container">
      <div
        data-testid={`countdown-percent-${progressPercentage}`}
        className="countdown"
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  )
}
